import type { StoreApi, UseBoundStore } from 'zustand';

import { createZustandStore } from '../createZustandStore';
import type {
  IBillingInfoFormSlice,
  IOrderSummarySlice,
  IPayflowProgressBarSlice,
  IPaymentButtonSlice,
  IPaymentMethodsSlice,
  IAlertSlice,
  IPromoCodesSlice,
  IEmailPlansSlice,
  IPrepaySelectSlice,
  IContactsTierSelectSlice,
  ICurrencySlice,
  INonProfitSlice,
  IPaymentProcessingInfoSlice,
  IPayflowTopBarSlice,
} from '../slices';
import {
  createBillingInfoFormSlice,
  createOrderSummarySlice,
  createPayflowProgressBarSlice,
  createPaymentButtonSlice,
  createPaymentMethodsSlice,
  createAlertSlice,
  createPromoCodesSlice,
  createEmailPlansSlice,
  createPrepaySelectSlice,
  createContactsTierSelectSlice,
  createCurrencySlice,
  createNonProfitSlice,
  createPaymentProcessingInfoSlice,
  createPayflowTopBarSlice,
} from '../slices';

export type IChangePaymentPlanPageStore = IBillingInfoFormSlice &
  IOrderSummarySlice &
  IPayflowProgressBarSlice &
  IPaymentButtonSlice &
  IPaymentMethodsSlice &
  IPrepaySelectSlice &
  ICurrencySlice &
  INonProfitSlice &
  IContactsTierSelectSlice &
  IAlertSlice &
  IPromoCodesSlice &
  IEmailPlansSlice &
  IPaymentProcessingInfoSlice &
  IPayflowTopBarSlice;

export const useChangePaymentPlanPageStore = createZustandStore(
  createBillingInfoFormSlice,
  createOrderSummarySlice,
  createPayflowProgressBarSlice,
  createAlertSlice,
  createPaymentButtonSlice,
  createPaymentMethodsSlice,
  createPrepaySelectSlice,
  createCurrencySlice,
  createNonProfitSlice,
  createContactsTierSelectSlice,
  createPromoCodesSlice,
  createEmailPlansSlice,
  createPaymentProcessingInfoSlice,
  createPayflowTopBarSlice
);

export type ChangePaymentPlanPageStore = UseBoundStore<StoreApi<IChangePaymentPlanPageStore>>;
